import {
  faBook,
  faBriefcase,
  faBuilding,
  faEnvelope,
  faFileInvoice,
  faHistory,
  faKey,
  faQuestionCircle,
  faUser,
  faUsers,
} from "@fortawesome/free-solid-svg-icons"
import { Layout } from "antd"
import React, { useEffect, useState } from "react"
import { useRecoilValue } from "recoil"
import { isInitializingState } from "recoils/initializingState"
import {
  isClientNotFoundState,
  isCompanyNotFoundState,
} from "recoils/isNotFoundState"
import styled from "styled-components"

import { useFirebaseLogOut } from "../../hooks/useFirebaseLogOut"
import { SideBarItem } from "../atoms/sidebar"

import type { SideBarItemIF } from "interfaces/SideBarItemIF"

const { Sider } = Layout

const StyledSideBar = styled(Sider)`
  background-color: #002766;
  padding-top: 1rem;
  padding-left: 3rem;
  text-align: left;
  color: white;
  text-decoration: none;
  position: fixed;
  height: 100vh;
`

export const DefaultSideBar: React.VFC = () => {
  const logOut = useFirebaseLogOut()
  const isClientNotFound = useRecoilValue(isClientNotFoundState)
  const isCompanyNotFound = useRecoilValue(isCompanyNotFoundState)

  const isInitializing = useRecoilValue(isInitializingState)
  const [isInitializingStarted, setIsInitializingStarted] = useState(false)

  useEffect(() => {
    if (isInitializing) setIsInitializingStarted(true)
  }, [isInitializing])

  const openEmail = (): void => {
    const email = process.env.REACT_APP_CONTACT_EMAIL || ""
    window.location.href = `mailto:${email}?subject=【船員求人広告】お問い合わせ`
  }

  const openTerms = (): void => {
    window.open("https://app-qjin-net.web.app/terms/", "_blank")
  }

  const linkList: SideBarItemIF[] = [
    {
      label: "求人登録画面",
      url: "/recruit",
      disabled: isClientNotFound || isCompanyNotFound,
      icon: faBriefcase,
    },
    {
      label: "求人閲覧履歴",
      url: "/recruit/visit-log",
      disabled: isClientNotFound || isCompanyNotFound,
      icon: faHistory,
    },
    {
      label: "応募者一覧",
      url: "/jobseeker",
      disabled: isClientNotFound || isCompanyNotFound,
      icon: faUsers,
    },
    {
      label: "会社情報",
      url: "/company",
      disabled: isClientNotFound,
      icon: faBuilding,
    },
    {
      label: "有料プラン",
      url: "/plan",
      disabled: isClientNotFound || isCompanyNotFound,
      icon: faFileInvoice,
    },
    { label: "プロフィール", url: "/profile", icon: faUser },
    { label: "メールアドレス変更", url: "/setting/email", icon: faEnvelope },
    { label: "パスワード変更", url: "/setting/password", icon: faKey },
    {
      label: "お問い合わせ",
      url: "#",
      action: openEmail,
      icon: faQuestionCircle,
    },
    {
      label: "利用規約",
      url: "#",
      action: openTerms,
      icon: faBook,
    },
    { label: "ログアウト", url: "#", action: logOut },
  ]

  const LinkItem = linkList.map((link) => {
    return (
      <SideBarItem
        key={link.label}
        label={link.label}
        url={link.url}
        action={link.action}
        icon={link.icon}
        disabled={!isInitializingStarted || isInitializing || link.disabled}
      />
    )
  })

  return <StyledSideBar width={240}>{LinkItem}</StyledSideBar>
}
